import React from 'react'
import PropTypes from 'prop-types'

import PhoneNumberInput from './PhoneNumberInput'
import OnboardingButton from './OnboardingButton'

import loginScreenContainer from './loginScreenContainer'
import usingOnboardingCard from './usingOnboardingCard'

import onboardingPhoneImage from 'resources/onboarding_phone.png'

class PhoneNumberScreen extends React.Component {

  static propTypes = {
    phoneInfo: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    onNextClicked: PropTypes.func.isRequired,
    onPhoneInfoChanged: PropTypes.func.isRequired
  }

  render() {
    return (
      <div style={styles.container}>
        <img src={onboardingPhoneImage} width={170} height={225} />
        <PhoneNumberInput
          disabled={this.props.loading}
          onPhoneInfoChanged={this.props.onPhoneInfoChanged}
          phoneInfo={this.props.phoneInfo}
          onEnterPressed={this.props.onNextClicked} />
        <OnboardingButton
          loading={this.props.loading}
          onButtonClicked={this.props.onNextClicked} />
      </div>
    )
  }

}

export default loginScreenContainer(usingOnboardingCard(PhoneNumberScreen))

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    height: '100%'
  }
}



// WEBPACK FOOTER //
// ./src/login/PhoneNumberScreen.js